import { render, staticRenderFns } from "./travel-insurance-form-step-1.vue?vue&type=template&id=77c22a30&scoped=true"
import script from "./travel-insurance-form-step-1.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-form-step-1.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-form-step-1.vue?vue&type=style&index=0&id=77c22a30&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c22a30",
  null
  
)

export default component.exports